
<project-details-info-features-stages [project]="project"></project-details-info-features-stages>

  <!-- PROJECT details features-->
  <article class="project-details-features">
    <div class="project-details-features-main">
      <div class="project-details-features-content-avatars">
        <!-- PROJECT OWNER AND ASIGNEE -->
        <div class="project-details-features-owner">
          <core-helper-box-header-user-date
          [date]="project.date_created"
          [user]="project.user_owner"
          [preText]="'<strong>Created by</strong>'"
          ></core-helper-box-header-user-date>
        </div>
        <!-- CONTROL ASIGNEE is set!!!-->
        <div class="project-details-features-asignee">
          <core-helper-box-header-user-assignee
            [user]="project.user_assigned"
            [preText]="'<strong>Assigned to</strong>'"
            [users]="assigners"
            (onSelectAssignee)="onSelectAssignee($event)"
          ></core-helper-box-header-user-assignee>
          <!-- delay-clock green-clock red-clock -->
          <div class="project-details-features-duedate" >
            <!-- will be allways calendar icon 15/2/2022 -->
            <core-helpers-forms-button-icon [text]="due.text" [icon]="due.icon" (click)="toggleCalendar()"></core-helpers-forms-button-icon>
          </div>
          <!-- DUEDATE - CALENDAR DATEPICKER -->
        </div>
      </div>
    </div>
    <div class="project-details-features-datepicker">
        <!-- this formatted date should not be changed because it is a parameter to the datepicker -->
      <core-helpers-forms-datepicker
        [selectedDate]="project.due_date | date: 'yyyy-MM-dd'"
        [hidden]="!showCalendar"
        [theme]="'dp-duedate'"
        (selectDate)="onSelectDate($event)"
        (close)="onClose()"
        ></core-helpers-forms-datepicker>
    </div>
  </article>
  <!-- End PROJECT details features -->
